import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, MapPin, ShoppingBag } from 'lucide-react';
type Purchase = {
  name: string;
  location: string;
  product: string;
  minutesAgo: number;
};
const purchases: Purchase[] = [{
  name: 'Marcela G.',
  location: 'Córdoba',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 2
}, {
  name: 'Luis P.',
  location: 'Mendoza',
  product: 'KIT Negocio Fitness IA',
  minutesAgo: 4
}, {
  name: 'Romina M.',
  location: 'Buenos Aires',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 6
}, {
  name: 'Paula A.',
  location: 'Tucumán',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 8
}, {
  name: 'Valentín L.',
  location: 'Rosario',
  product: 'KIT Negocio Fitness IA',
  minutesAgo: 11
}, {
  name: 'Daniela M.',
  location: 'La Plata',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 13
}, {
  name: 'Santiago C.',
  location: 'Salta',
  product: 'KIT Negocio Fitness IA',
  minutesAgo: 15
}, {
  name: 'Florencia R.',
  location: 'Neuquén',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 18
}, {
  name: 'Matías D.',
  location: 'Mar del Plata',
  product: 'KIT Negocio Fitness IA',
  minutesAgo: 21
}, {
  name: 'Camila B.',
  location: 'San Juan',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 24
}, {
  name: 'Joaquín F.',
  location: 'Bariloche',
  product: 'KIT Negocio Fitness IA',
  minutesAgo: 27
}, {
  name: 'Sofía T.',
  location: 'Santa Fe',
  product: 'KIT + Protocolo 24/7',
  minutesAgo: 31
}];
const VISIBLE_MS = 5500;
const GAP_MS = 7000;
const INITIAL_DELAY_MS = 4000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const cycle = (delay: number) => {
      showTimer = setTimeout(() => {
        setVisible(true);
        hideTimer = setTimeout(() => {
          setVisible(false);
          setIndex(i => (i + 1) % purchases.length);
          cycle(GAP_MS);
        }, VISIBLE_MS);
      }, delay);
    };
    cycle(INITIAL_DELAY_MS);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, []);
  const current = purchases[index];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none max-w-[calc(100vw-2rem)] sm:max-w-sm" data-id="element-527">
      <AnimatePresence mode="wait" data-id="element-528">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        y: 10
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto relative bg-graphite/95 backdrop-blur-md border border-electric/40 rounded-2xl shadow-2xl shadow-electric/20 p-3 pr-4 flex items-center gap-3 overflow-hidden" data-id="element-529">
            {/* subtle glow */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-electric/30 via-energy/20 to-electric/30 rounded-2xl blur-md opacity-50 -z-10" data-id="element-530"></div>

            {/* Icon */}
            <div className="relative flex-shrink-0 w-10 h-10 rounded-xl bg-electric/15 border border-electric/30 flex items-center justify-center" data-id="element-531">
              <ShoppingBag className="w-5 h-5 text-electric" strokeWidth={2.2} data-id="element-532" />
              <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-electric rounded-full border-2 border-graphite flex items-center justify-center" data-id="element-533">
                <Check className="w-2 h-2 text-graphite" strokeWidth={4} data-id="element-534" />
              </span>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-535">
              <p className="text-sm text-white leading-tight" data-id="element-536">
                <span className="font-bold" data-id="element-537">{current.name}</span>{' '}
                <span className="text-textsecondary" data-id="element-538">acaba de comprar el</span>
              </p>
              <p className="text-xs text-electric font-semibold truncate mt-0.5" data-id="element-539">
                {current.product}
              </p>
              <div className="flex items-center gap-2 mt-1 text-[10px] text-textsecondary" data-id="element-540">
                <span className="flex items-center gap-1" data-id="element-541">
                  <MapPin className="w-2.5 h-2.5" data-id="element-542" />
                  {current.location}
                </span>
                <span className="text-electric/40" data-id="element-543">·</span>
                <span data-id="element-544">hace {current.minutesAgo} min</span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}